function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiploma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 12.668 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.334 8a.667.667 0 0 1 0 1.333h-2a.667.667 0 0 1 0-1.333zm4-2a.667.667 0 0 0-.667-.667H6.334a.667.667 0 0 0 0 1.333h5.334A.667.667 0 0 0 12.334 6zm-6-2h5.334a.667.667 0 0 0 0-1.333H6.334a.667.667 0 0 0 0 1.333zm8 8.963v2.556a.481.481 0 0 1-.821.34L13 15.347l-.513.512a.481.481 0 0 1-.821-.34v-2.555A2.658 2.658 0 0 1 13 8a2.626 2.626 0 0 1 .667.095V3.334a2 2 0 0 0-2-2H6.334a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3.333a.667.667 0 1 1 0 1.333H6.334A3.338 3.338 0 0 1 3 11.334v-8A3.338 3.338 0 0 1 6.334 0h5.334A3.338 3.338 0 0 1 15 3.334v5.588a2.634 2.634 0 0 1-.667 4.042zm0-2.3A1.333 1.333 0 1 0 13 12a1.333 1.333 0 0 0 1.334-1.333z",
    transform: "translate(-3)",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.435f91db72acbbc1ac11f1f7d4638e77.svg";
export { ForwardRef as ReactComponent };